import angular from "angular"
import moment from "moment"
import routing from "./availabilitycheck.routes"
import { dateAsString, getMomentDateInFuture, getMomentDateInPast } from "../shared/utils"

const POLMANTER_LIMITED_NIGHTS_NUMBER = 2

// function getMomentDate(dateString) {
//   return moment(dateString, "DD/MM/YYYY")
// }

// todo these should be set on campsite data
// { start: "01/04/2025", end: "24/07/2025" },
// { start: "29/08/2025", end: "30/10/2025" },
// const POLMANTER_LIMITED_DATE_RANGES = [{ start: "01/04/2025", end: "30/12/2026" }]

function checkIsPitchBookingLimited(startDate, endDate) {
  let startDateAsMoment = moment(startDate)
  let endDateAsMoment = moment(endDate)
  const lengthOfStay = endDateAsMoment.diff(startDateAsMoment, "days")

  return lengthOfStay <= POLMANTER_LIMITED_NIGHTS_NUMBER
  // return (
  //   lengthOfStay <= POLMANTER_LIMITED_NIGHTS_NUMBER &&
  //   POLMANTER_LIMITED_DATE_RANGES.some((dateRange) =>
  //     startDateAsMoment.isBetween(getMomentDate(dateRange.start), getMomentDate(dateRange.end), "days", "[]")
  //   )
  // )
}

export class AvailabilityCheckComponent {
  loading = false

  /*@ngInject*/
  constructor($http, $q, $timeout, $state, $stateParams, $sce, anytimeService, $scope) {
    this.anytimeService = anytimeService
    this.$http = $http
    this.$q = $q
    this.$timeout = $timeout
    this.$state = $state
    this.$stateParams = $stateParams
    this.$sce = $sce
    this.initData = null
    this.$scope = $scope
  }

  $onChanges(changes) {
    if (changes.availabilityTransition) {
      const { currentValue, previousValue } = changes?.availabilityTransition
      const hadPreviousValue = previousValue === false || previousValue === undefined
      if (
        currentValue &&
        hadPreviousValue &&
        (this.campsiteinfo.showOccupancyChoices ? this.minMaxOccupantTypesForUnitsData : true)
      ) {
        this.checkIfAvailabilityPopulated()
      }
    }
    if (this.campsiteinfo.showOccupancyChoices && changes.minMaxOccupantTypesForUnitsData?.currentValue) {
      this.checkIfAvailabilityPopulated()
    }
  }

  $onInit() {
    this.accomodationtype = ""
    if (this.campsiteinfo.booksystemname === "GemaPark") {
      this.$http.get(`/api/availability/GetAccommodationTypes/${this.campsiteinfo.name}`).then(
        (response) => {
          this.accomodationtypes = response.data.data
        },
        (reject) => {
          //this is a rejection
          console.error(reject)
        }
      )
    }
    if (this.campsiteinfo.booksystemname === "Anytime") {
      this.anytimeService.getAccomodationTypes(this.campsiteinfo.name).then((accomodationtypes) => {
        this.accomodationtypes = accomodationtypes
        this.setAnytimePricingAndMinimumNightsData()
      })
    }

    this.checkIfAvailabilityPopulated()
    if (this.campsiteinfo.booksystemname === "GemaPark") {
      this.$http.get(`/api/availability/GetCategories/${this.campsiteinfo.name}`).then((response) => {
        this.categoryData = response.data.data
      })
    }

    if (this.campsiteinfo.booksystemname === "Anytime") {
      this.$http.get(`/api/availability/GetAnytimeCategories/${this.campsiteinfo.name}`).then((response) => {
        const categoryData = response.data.map((item) => ({ categoryID: item.id, name: item.name }))
        categoryData.unshift({ categoryID: "all", name: "All categories" })
        this.categoryData = categoryData
      })
    }
  }

  checkIfAvailabilityPopulated() {
    if (
      this.$stateParams.categorytype &&
      this.$stateParams.accomtype &&
      this.$stateParams.startdate &&
      this.$stateParams.enddate
    ) {
      this.initData = {
        categoryId: Number(this.$stateParams.categorytype),
        unitId: this.$stateParams.accomtype === "null" ? null : Number(this.$stateParams.accomtype),
        startDate: moment(this.$stateParams.startdate),
        endDate: moment(this.$stateParams.enddate),
        numOfAdults: Number(this.$stateParams?.numofadults),
        numOfChildren: Number(this.$stateParams?.numofchildren),
        numOfInfants: Number(this.$stateParams?.numofinfants),
      }

      this.categorytype = this.$stateParams.categorytype
      this.accomodationtype = this.$stateParams.accomtype
      this.startDate = moment(this.$stateParams.startdate).toDate()
      this.endDate = moment(this.$stateParams.enddate).toDate()

      this.setAvailParamsInRootForStateChange({ event: this.initData })

      this.doAvailabilitiesCheck()
    }
  }

  closeAvailabilityShowingBox = () => {
    this.checkShowingOnLoad = false
    this.onClose()
  }

  setAnytimePricingAndMinimumNightsData() {
    this.anytimeService.getMinNightsAndPricing(this.campsiteinfo.name).then((value) => {
      this.anytimeMinNightsAndPricingDataAllUnits = value
    })
  }

  getGemaParkAvailabilityFromDates(startDateStr, endDateStr) {
    let physicalUnitCallPromises = []
    let availablePhysicalUnitNumbers = []

    let unitIdsForPhysicalUnitIds = []

    const {
      categorytype: categoryType,
      accomtype: accomodationType,
      numofadults: numOfAdults,
      numofchildren: numOfChildren,
      numofinfants: numOfInfants,
    } = this.$stateParams

    const occupancyParams =
      numOfAdults && numOfChildren && numOfInfants ? `/${numOfAdults}/${numOfChildren}/${numOfInfants}` : ""

    return new Promise((resolve) => {
      this.$http
        .get(
          `/api/availability/GetUnits/${this.campsiteinfo.name}/${categoryType}/${accomodationType}/${startDateStr}/${endDateStr}${occupancyParams}`
        )
        .then((response) => response.data.data)
        .then((unitsData) => {
          if (unitsData) {
            let isPitchBookingLimited = false

            if (this.campsiteinfo.name === "polmanter") {
              isPitchBookingLimited = checkIsPitchBookingLimited(this.startDate, this.endDate)
            }

            unitsData.forEach((unit) => {
              let promise = this.$http
                .get(
                  `/api/availability/GetPhysicalUnits/${this.campsiteinfo.name}/${accomodationType}/${unit.unitID}/${startDateStr}/${endDateStr}`
                )
                .then((physicalUnitsData) => {
                  physicalUnitsData.data.data.forEach((physicalunit) => {
                    if (!unitIdsForPhysicalUnitIds[physicalunit.physicalUnitID]) {
                      unitIdsForPhysicalUnitIds[physicalunit.physicalUnitID] = physicalunit.unitID
                    }
                    // todo get numbers at end of name
                    // availablePhysicalUnitNumbers.push(physicalunit.name.replace("Pitch ", ""));
                    availablePhysicalUnitNumbers.push(physicalunit.physicalUnitID)
                  })
                  return physicalUnitsData.data.data
                })
              physicalUnitCallPromises.push(promise)
            })
            this.$q.all(physicalUnitCallPromises).then(() => {
              if (availablePhysicalUnitNumbers.length > 0) {
                resolve({ unitIdsForPhysicalUnitIds, availablePhysicalUnitNumbers, unitsData, isPitchBookingLimited })
              } else {
                resolve({ unitIdsForPhysicalUnitIds: [], availablePhysicalUnitNumbers: [], unitsData })
              }
            })
          } else {
            resolve({ unitIdsForPhysicalUnitIds: [], availablePhysicalUnitNumbers: [], unitsData })
          }
        })
    })
  }

  getFlexibleDates(startDateStr, endDateStr) {
    const startDateMinusOneDay = getMomentDateInPast(moment(startDateStr), 1)
    const endDateMinusOneDay = getMomentDateInPast(moment(endDateStr), 1)
    const dateStringOneBefore = startDateMinusOneDay.format("ddd Do MMM")

    const startDatePlusOneDay = getMomentDateInFuture(moment(startDateStr), 1)
    const endDatePlusOneDay = getMomentDateInFuture(moment(endDateStr), 1)
    const dateStringOneAhead = startDatePlusOneDay.format("ddd Do MMM")

    const flexibleData = [
      { start: dateAsString(startDateMinusOneDay), end: dateAsString(endDateMinusOneDay) },
      { start: dateAsString(startDatePlusOneDay), end: dateAsString(endDatePlusOneDay) },
    ]

    return new Promise((resolveAllFlexibleData) => {
      let flexibleDatePromises = []
      flexibleData.forEach((flexibleDate) => {
        flexibleDatePromises.push(this.getGemaParkAvailabilityFromDates(flexibleDate.start, flexibleDate.end))
      })

      this.$q.all(flexibleDatePromises).then((result) => {
        const dataForResolve = {
          oneBehind: { numOfPitches: result[0].availablePhysicalUnitNumbers.length, dateString: dateStringOneBefore },
          oneAhead: { numOfPitches: result[1].availablePhysicalUnitNumbers.length, dateString: dateStringOneAhead },
        }
        resolveAllFlexibleData(dataForResolve)
      })
    })
  }

  doGemaParkAvailabiltiesCheck() {
    const { startdate: startDateStr, enddate: endDateStr } = this.$stateParams

    this.getGemaParkAvailabilityFromDates(startDateStr, endDateStr).then((result) => {
      const { unitIdsForPhysicalUnitIds, availablePhysicalUnitNumbers, unitsData, isPitchBookingLimited } = result
      this.loading = false

      this.noResults = availablePhysicalUnitNumbers.length === 0 && !isPitchBookingLimited

      if (!this.noResults) {
        this.updateChosenAvailabilityDates({
          event: {
            accomodationType: this.accomodationtype,
            unitsData,
            unitIdsForPhysicalUnitIds,
            availablePhysicalUnitNumbers,
            startDate: this.startDate,
            endDate: this.endDate,
            numOfAdults: this.initData.numOfAdults,
            numOfChildren: this.initData.numOfChildren,
            numOfInfants: this.initData.numOfInfants,
            isPitchBookingLimited,
          },
        })
      } else {
        this.setAvailabilityTransitionFalse()
        if (!this.$scope.$$phase) {
          this.$scope.$apply()
        }
      }

      if (this.campsiteinfo.showFlexibleDates) {
        this.getFlexibleDates(startDateStr, endDateStr).then((result) => {
          if (result) {
            this.updateFlexibilityData({
              event: {
                flexData: result,
              },
            })
          }
        })
      }
    })
  }

  doAnytimeAvailabiltiesCheck() {
    this.anytimeService
      .getAnytimeUnitAndCategoryGroupingMap(this.campsiteinfo.name)
      .then((unitAndGrouping) => this.setAnytimeAvailabilities(unitAndGrouping))
  }

  getStartDateAsMoment() {
    const startDateStr = this.$stateParams.startdate
    return moment(startDateStr)
  }

  getEndDateAsMoment() {
    const endDateStr = this.$stateParams.enddate
    return moment(endDateStr)
  }

  getAnytimeAvailabilityFromDates(allAvailableAnytimeData) {
    const startDateMoment = this.getStartDateAsMoment()
    const endDateMoment = this.getEndDateAsMoment()
    const endDateMinusOneDay = getMomentDateInPast(endDateMoment, 1)
    const endDateMinusOneDayAsString = dateAsString(endDateMinusOneDay)
    const numOfDays = endDateMoment.diff(startDateMoment, "days") + 1
    let availablePhysicalUnitNumbers = []
    return new Promise((resolve) => {
      this.$http
        .post(
          `/api/availability/GetAnytimeAvailability/${this.campsiteinfo.name}/${this.$stateParams.startdate}/${endDateMinusOneDayAsString}`,
          { data: allAvailableAnytimeData.subUnitsArray }
        )
        .then((response) => {
          const idsCounts = {}
          const allAvailableSubUnitsForAllDays = response.data.filter((item) => item.level !== 0)
          allAvailableSubUnitsForAllDays.forEach((item) => {
            if (idsCounts[item.unit_id]) {
              idsCounts[item.unit_id] = idsCounts[item.unit_id] + 1
            } else {
              idsCounts[item.unit_id] = 1
            }
          })

          const unitIdsPresentOnAllDays = []

          for (let [key, value] of Object.entries(idsCounts)) {
            if (value === numOfDays) {
              unitIdsPresentOnAllDays.push(Number(key))
            }
          }

          if (unitIdsPresentOnAllDays.length) {
            availablePhysicalUnitNumbers = unitIdsPresentOnAllDays
          }
          resolve({ availablePhysicalUnitNumbers })
        })
    })
  }

  convertStringToNumber = (stringValue) => parseInt(stringValue, 10)

  setAnytimeAvailabilities(unitAndGrouping) {
    let allAvailableAnytimeData
    let eventExtraProps
    if (this.categorytype && this.categorytype !== "null") {
      if (this.categorytype === "all") {
        const dataForAllCategories = []
        unitAndGrouping.categoryGrouping.forEach((option) => dataForAllCategories.push(option))
        allAvailableAnytimeData = dataForAllCategories
      } else {
        const categoryIdAsNumber = this.convertStringToNumber(this.categorytype)
        allAvailableAnytimeData = unitAndGrouping.categoryGrouping.get(categoryIdAsNumber)
      }
    }

    if (this.accomodationtype && this.accomodationtype !== "null") {
      const unitIdAsNumber = this.convertStringToNumber(this.accomodationtype)
      allAvailableAnytimeData = unitAndGrouping.unitGrouping.get(unitIdAsNumber)
      eventExtraProps = { accomodationUnitId: unitIdAsNumber }
    }
    if (allAvailableAnytimeData) {
      this.getAnytimeAvailabilityFromDates(allAvailableAnytimeData).then((result) => {
        const { availablePhysicalUnitNumbers } = result
        let startDateAsMoment = moment(this.startDate)
        let endDateAsMoment = moment(this.endDate)
        const lengthOfStay = endDateAsMoment.diff(startDateAsMoment, "days")

        this.loading = false

        this.noResults = availablePhysicalUnitNumbers.length === 0

        if (!this.noResults) {
          this.updateChosenAvailabilityDates({
            event: {
              allAvailableAnytimeData,
              accomodationType: this.accomodationtype,
              categoryId: this.categorytype,
              skipIndividualPitchAvailability: lengthOfStay < this.campsiteinfo.minNumberOfNightsForPitchBookings, // todo refactor and remove this
              unitIdsForPhysicalUnitIds: null,
              availablePhysicalUnitNumbers,
              startDate: this.startDate,
              endDate: this.endDate,
              ...eventExtraProps,
            },
          })
        } else {
          this.setAvailabilityTransitionFalse()
          if (!this.$scope.$$phase) {
            this.$scope.$apply()
          }
        }
      })
    } else {
      this.loading = false
    }
  }

  doAvailabilitiesCheck() {
    this.loading = true
    this.resetMarkerDots()

    if (this.campsiteinfo.booksystemname === "GemaPark") {
      this.doGemaParkAvailabiltiesCheck()
    }

    if (this.campsiteinfo.booksystemname === "Anytime") {
      this.anytimeService
        .getAnytimeUnitAndCategoryGroupingMap(this.campsiteinfo.name)
        .then((unitAndGrouping) => this.setAnytimeAvailabilities(unitAndGrouping))
    }
  }

  doCheck = (e) => {
    this.noResults = false
    this.loadAvailCheckRoute({
      event: e,
    })
  }
}

export default angular
  .module("directives.availabilitycheck", [])
  .config(routing)
  .component("availabilitycheck", {
    template: require("./availabilitycheck.html"),
    controller: AvailabilityCheckComponent,
    bindings: {
      campsiteinfo: "<",
      onClose: "&",
      updateChosenAvailabilityDates: "&",
      updateFlexibilityData: "&",
      resetMarkerDots: "&",
      resetAvailability: "&",
      availabilityTransition: "<",
      availabilityCheckShowing: "<",
      setAvailabilityTransitionFalse: "&",
      minMaxOccupantTypesForUnitsData: "<",
      loadAvailCheckRoute: "&",
      setAvailParamsInRootForStateChange: "&",
    },
  }).name
